import { Container } from '@cgs/wge';
import { IconEnumerator } from '../../reels_engine/icon_enumerator';
import { LongStoppingIconEnumerator } from '../../reels_engine/long_stopping_icons_enumerator';
import { SlotParams } from '../../reels_engine/slot_params';
import { T_IGameParams } from '../../type_definitions';

export class LongStoppingIconEnumeratorProvider {
  public readonly iconsEnumerator: IconEnumerator;

  constructor(container: Container, iconIds: number[], replaceId: number = 6) {
    console.log('load ' + this.constructor.name);
    const slotParams = container.resolve<SlotParams>(T_IGameParams);

    this.iconsEnumerator = new LongStoppingIconEnumerator(
      slotParams.reelsCount,
      slotParams.linesCount,
      slotParams.longIcons,
      iconIds,
      replaceId
    );
  }
}
